'use client';
import { useEffect, useState } from 'react';
import { AuthContext, useAuthProvider } from '../hooks/useAuth';

export function Providers({ children }: { children: React.ReactNode }) {
  const auth = useAuthProvider();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div className="flex items-center justify-center min-h-screen">Chargement...</div>;
  }

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}
